// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customer-service-faq[data-v-e66be36e]{--text-opacity:1;color:#333;color:rgba(51,51,51,var(--text-opacity))}.customer-service-faq .border-b[data-v-e66be36e]{border-color:#dadada}.customer-service-faq .second-list .border-b[data-v-e66be36e]:last-child{border-style:none}@media (min-width:1024px){.first-list .border-b[data-v-e66be36e]:last-child{border-style:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
